import Api from "../Api";

const basePath = '/dealers';

export default {
    getDealers : () => Api.get(`${basePath}`)
}



// WEBPACK FOOTER //
// ./src/services/api/DealerService.js